import React, { useState } from "react";
import { getCardImage } from "../../casinoComponents/resultVisuals/cardAssets";
import { formatRangeVal } from "../../casinoComponents/betTableLucky7/lucky7Utils";
import { formatBook } from "../../../utils/formatOdds";
import Collapse from "../../../components/Collapse";
import CardImg from "../../../components/CardImg";

const CARDS = `${import.meta.env.BASE_URL}img/cards`;
const PLAYERS = [1, 2, 3, 4, 5, 6];

// Row labels of the reference grid (row i uses main[i + 9 * player])
const suitImgs = (names) => (
  <span>
    {names.map((n, i) => (
      <React.Fragment key={n}>
        {i > 0 && " "}
        <img src={`${CARDS}/${n}.png`} alt="" />
      </React.Fragment>
    ))}
  </span>
);
const ROWS = [
  { label: <b>Winner</b> },
  { img: true, label: suitImgs(["spade", "club"]) },
  { img: true, label: suitImgs(["heart", "diamond"]) },
  { label: <b>Odd</b> },
  { label: <b>Even</b> },
  { img: true, label: suitImgs(["spade"]) },
  { img: true, label: suitImgs(["club"]) },
  { img: true, label: suitImgs(["heart"]) },
  { img: true, label: suitImgs(["diamond"]) },
];

/**
 * Casino War bet grid in the reference (IS_TABLET, ≥768px) markup:
 *   .teen1daycasino-container > .casino-war-container >
 *     card row (6 player cards) + .casino-war-title (1–6) + 9 market rows × 6 players
 *   (markets = sub with subtype "war" ordered by sr; player p's market for row i is main[i + 9p]).
 */
export default function BetTableWar({ sub = [], cards = [], exposures = {}, onOdds }) {
  const [openRange, setOpenRange] = useState({});
  const main = (Array.isArray(sub) ? sub : [])
    .filter((m) => m?.subtype === "war")
    .slice()
    .sort((a, b) => (Number(a?.sr) || 0) - (Number(b?.sr) || 0));
  const exp = (m) => {
    const v = exposures[m?.nat] ?? exposures[String(m?.nat || "").toLowerCase()];
    return v != null ? Number(v) || 0 : 0;
  };

  return (
    <div className="teen1daycasino-container">
      <div className="casino-war-container">
        <div className="casino-box-row">
          <div className="casino-nation-name no-border" />
          {PLAYERS.map((p) => (
            <React.Fragment key={p}>
              {" "}
              <div className="casino-bl-box">
                <div className="casino-bl-box-item casino-card-img">
                  <span>
                    <CardImg src={getCardImage(cards[p - 1])} alt="" />
                  </span>
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>{" "}
        <div className="casino-box-row casino-war-title">
          <div className="casino-nation-name no-border" />
          {PLAYERS.map((p) => (
            <React.Fragment key={p}>
              {" "}
              <div className="casino-bl-box">
                <div className="casino-bl-box-item">
                  <b>{p}</b>
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>{" "}
        {ROWS.map((row, i) => {
          const head = main[i] || {};
          const id = `minmaxinfo${i}`;
          return (
            <div key={i} className="casino-box-row">
              <div className={`casino-nation-name${row.img ? " casino-card-img" : ""}`}>
                {row.label}{" "}
                <div className="float-right">
                  <i
                    data-toggle="collapse"
                    data-target={`#${id}`}
                    className="fas fa-info-circle"
                    onClick={() => setOpenRange((v) => ({ ...v, [id]: !v[id] }))}
                  />{" "}
                  <Collapse id={id} open={!!openRange[id]} className="icon-range">
                    {"\n                                                R:"}
                    <span>{formatRangeVal(head.min)}</span>-<span>{formatRangeVal(head.max)}</span>
                  </Collapse>
                </div>
              </div>
              {PLAYERS.map((p) => {
                const m = main[i + 9 * (p - 1)] || {};
                const open = String(m.gstatus || "").toUpperCase() === "OPEN";
                const e = exp(m);
                return (
                  <React.Fragment key={p}>
                    {" "}
                    <div className={`casino-bl-box${open ? "" : " suspended"}`} onClick={() => onOdds?.(m)}>
                      <div className="back casino-bl-box-item">
                        <span className="casino-box-odd">{m.b ?? 0}</span>{" "}
                        <span className={`casino-book ${e > 0 ? "book-green" : "book-red"}`}>{formatBook(e)}</span>
                      </div>
                    </div>
                  </React.Fragment>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}
